export default __webpack_public_path__ + "static/s11-eb0e73c11324f21a2ba357614fcf9ada.png";